import Looks3Icon from '@mui/icons-material/Looks3';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import { Box, SxProps, Theme } from '@mui/material';

const styles = {
  goldMedal: {
    color: '#FFD700',
    fontSize: '1.5rem',
    filter: 'drop-shadow(0 0 2px rgba(255, 215, 0, 0.5))',
  },
  silverMedal: {
    color: '#C0C0C0',
    fontSize: '1.5rem',
    filter: 'drop-shadow(0 0 2px rgba(192, 192, 192, 0.5))',
  },
  bronzeMedal: {
    color: '#CD7F32',
    fontSize: '1.5rem',
    filter: 'drop-shadow(0 0 2px rgba(205, 127, 50, 0.5))',
  },
  rankCell: {
    color: '#ffffff',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
};

interface RankIconProps {
  rank: number;
  containerSx?: SxProps<Theme>;
}

/**
 * A reusable component for displaying rank icons (medals for top 3, numbers for others)
 */
const RankIcon = ({ rank, containerSx }: RankIconProps) => {
  // Function to get the appropriate rank icon
  const getIcon = () => {
    switch (rank) {
      case 0:
        return <LooksOneIcon sx={styles.goldMedal} />;
      case 1:
        return <LooksTwoIcon sx={styles.silverMedal} />;
      case 2:
        return <Looks3Icon sx={styles.bronzeMedal} />;
      default:
        return rank + 1;
    }
  };

  return <Box sx={{ ...styles.rankCell, ...containerSx }}>{getIcon()}</Box>;
};

export default RankIcon;
